<div class="support-tickets-container">
  <div class="page-header">
    <h3>Support Tickets</h3>
    <button class="btn btn-primary btn-search btn-new-ticket px-4" (click)="createTicket()">Create Ticket</button>
  </div>

  <div class="filters-card">
    <div class="row align-items-end">
      <div class="col-md-2">
        <label class="form-label">Status</label>
        <select class="form-control" [(ngModel)]="selectedStatus">
          <option [ngValue]="null">All Statuses</option>
          <option *ngFor="let s of SupportTicketStatusArray" [ngValue]="s.id">{{s.name}}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label">Date Range</label>
        <select class="form-control" [(ngModel)]="selectedDateRange" (change)="updateDateInputs()">
          <option>All Time</option>
          <option>Week</option>
          <option>Month</option>
          <option>Custom</option>
        </select>
      </div>
      <div class="col-md-2" *ngIf="selectedDateRange === 'Custom'">
        <label class="form-label">Start Date</label>
        <input type="date" class="form-control" [(ngModel)]="startDate">
      </div>
      <div class="col-md-2" *ngIf="selectedDateRange === 'Custom'">
        <label class="form-label">End Date</label>
        <input type="date" class="form-control" [(ngModel)]="endDate">
      </div>
      <div class="col-md-2 text-md-right">
        <button class="btn btn-primary btn-search px-4" (click)="applyFilters()">Search</button>
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>

  <div *ngIf="error" class="alert alert-danger">{{error}}</div>
  <div *ngIf="!loading && tickets.length === 0" class="alert alert-info shadow-sm">No support tickets found.</div>

  <div class="table-wrapper" *ngIf="!loading && tickets.length > 0">
    <table class="custom-table">
      <thead>
        <tr>
          <th>Title</th>
          <th>Description</th>
          <th>Type</th>
          <th>Status</th>
          <th class="details-col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let t of tickets">
          <td>{{t.Title}}</td>
          <td>{{t.Description}}</td>
          <td>
            <span class="badge" [ngClass]="getTypeLabelClass(t.Type)">{{ SupportTicketType[t.Type] }}</span>
          </td>
          <td>
            <span class="badge" [ngClass]="getStatusLabelClass(t.Status)">{{ SupportTicketStatus[t.Status] }}</span>
          </td>
          <td class="details-col">
            <fa-icon [icon]="faEye" class="text-primary action-icon mr-3" title="View Ticket" role="button" tabindex="0"
              (click)="viewTicket(t.SupportTicketId)"></fa-icon>
            <fa-icon [icon]="faStatus" class="text-danger action-icon" title="Mark Closed" role="button" tabindex="0"
              (click)="changeStatus(t.SupportTicketId, 3)" *ngIf="t.Status !== 3"></fa-icon>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="pagination-wrapper" *ngIf="!loading && tickets.length > 0">
    <div class="row align-items-center">
      <div class="col-md-6">
        <div class="text-muted">Showing {{tickets.length}} of {{totalItems}} records</div>
      </div>
      <div class="col-md-6">
        <nav *ngIf="pager.totalPages > 0" aria-label="Page navigation">
          <ul class="pagination justify-content-end mb-0">
            <li class="page-item" [class.disabled]="page === 1">
              <a class="page-link" (click)="setPage(1)">First</a>
            </li>
            <li class="page-item" [class.disabled]="page === 1">
              <a class="page-link" (click)="prevPage()">Previous</a>
            </li>
            <li class="page-item" *ngFor="let p of pager.pages" [class.active]="p === page">
              <a class="page-link" (click)="setPage(p)">{{p}}</a>
            </li>
            <li class="page-item" [class.disabled]="page === pager.totalPages">
              <a class="page-link" (click)="nextPage()">Next</a>
            </li>
            <li class="page-item" [class.disabled]="page === pager.totalPages">
              <a class="page-link" (click)="setPage(pager.totalPages)">Last</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>